import './Login.scss'
import './ShowPassword.scss'

import React, {Component} from 'react'
import { Button, Input } from 'react-bootstrap'
import RdcBrandedLogo from './RdcBrandedLogo'
import PasswordHideIcon from './PasswordHideIcon'
import PasswordShowIcon from './PasswordShowIcon'


import { login } from 'common/redux/auth'

class Login extends Component {

    constructor(props) {
      super(props)
      this.state = {
        username: '',
        password: '',
        type: 'password',
        credentialsError: '',

      }
      this.handleSubmit = this.handleSubmit.bind(this)
      this.showHide = this.showHide.bind(this);
    }

    handleSubmit(e) {
      e.preventDefault()
      const isValid = this.validate()
        if (isValid) {
          this.props.dispatch(login(this.state.username, this.state.password))
        }
    }

    showHide(e){
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        type: this.state.type === 'password' ?  'input' : 'password' 
      })  
    }

    validate = () => {
      let credentialsError=''

      // currently removing email validation to allow non-email users to access the portal. Just keeping the commented part, so that in future if we decided to use only email as a username.
      // if (!this.state.username.includes('@')) {
      //   usernameError = 'Not a valid email password combo'        
      // }

      if (!this.state.username || !this.state.username.length || this.state.password.length < 1) {
        credentialsError = 'Not a valid email/username and password combo'
      }
      if (credentialsError) {
        this.setState({credentialsError})
        return false
      }
      return true
    }

 

    render() {
      const { serverError } = this.props
      const {username, password, credentialsError} = this.state
      const isEnabled = username.length > 1 && password.length > 1
      const borderColorIfValidationFails = (credentialsError || serverError) ? "password__input invalid" : "password_input"
      const labelColorIfValidationFails =  (credentialsError || serverError) ? "password invalid" : "password"
      const showPasswordErrorText = credentialsError || serverError
      const errorText = "Not a valid email/username and password combo"
      
      return (
        <div className='Login'>
          <form name="login-form" onSubmit={this.handleSubmit}>
              <RdcBrandedLogo />
              <div className="Login__subtitle">Welcome!
              </div>
              <div className='login-inner'>
                <label className={labelColorIfValidationFails}>Email or username
                 <input 
                  type="text" 
                  placeholder="email or username"  
                  className={borderColorIfValidationFails}
                  value={this.state.username} 
                  onChange={(e) => this.setState({username:e.target.value})}
                  />
                </label>

                <label className={labelColorIfValidationFails}>Password
                  <input 
                  name="password-input"
                  type={this.state.type} 
                  placeholder="password" 
                  className={borderColorIfValidationFails} 
                  value={this.state.password} 
                  onChange={(e) => this.setState({password:e.target.value})} />      
                  { (this.state.password.length > 0) ?
                    <div className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? <PasswordHideIcon /> : <PasswordShowIcon /> }
                    </div> : null
                  }
                </label>
              </div>
              <div>
                  {showPasswordErrorText ? (
                    <div name="error-login-color" style ={{ fontFamily: 'Rubik', fontSize: 11, marginTop: -20, position: 'absolute',  color: '#D92228'}}>
                    {errorText}
                  </div>
                  ) : null}
              </div> 
                                
              <div>
                {isEnabled ? <Button bsClass="Login__login_button_active"  type="submit" > Log in </Button>  :
                <Button bsClass="Login__login_button"  type="submit"> Log in 
                </Button>  
                }
              </div>
              <div className="Login__forgot"><a href="/reset_password" className="Login__forgot__link">Forgot password?</a>
              </div> 
          </form>
        </div>
      )
    }
}

export default Login
